import { useEffect, useState } from "react";
import { OrderTransport } from "src/app/transports/order";
import { OrderOffSiteGrid } from "src/app/types/orders/offSite";

const useHistoryByMoneySiteOffSiteList = (moneySiteId?: number) => {
    const [historyByMoneySiteOffSite, setHistoryByMoneySiteOffSite] =
        useState<Array<OrderOffSiteGrid>>();
    const [error, setError] = useState<any>();
    const [loading, setLoading] = useState(false);

    const fetch = () => {
        if (!moneySiteId) return;
        setLoading(true);

        OrderTransport.listHistoryByMoneySiteOffSite(moneySiteId)
            .then((res) => {
                setHistoryByMoneySiteOffSite(res);
            })
            .catch((err) => {
                setError(err);
            })
            .finally(() => setLoading(false));
    };

    const refreshHistory = () => {
        if (!loading) fetch();
    };

    useEffect(() => {
        fetch();
    }, [moneySiteId]);

    return { historyByMoneySiteOffSite, loading, error, refreshHistory };
};

export default useHistoryByMoneySiteOffSiteList;
